export enum FileType {
    AuctionHomePicture = "AuctionHomePicture",
    AuctionPicture = "AuctionPicture",
    AuctionPictureThumbnail = "AuctionPictureThumbnail",
    AuctionMap = "AuctionMap",
    ParcelCustom = "ParcelCustom",
    ParcelPicture = "ParcelPicture",
    ParcelPictureThumbnail = "ParcelPictureThumbnail",
    ParcelLandTitle = "ParcelLandTitle",
    ParcelPurchaseAgreement = "ParcelPurchaseAgreement",
    RawPicture = "RawPicture",
    TinyMCEPicture = "TinyMCEPicture"
}
